import React, { useState } from 'react';
import { Button } from './ui/button';

const reviews = [
  {
    id: 1,
    name: "María González",
    rating: 5,
    comment: "Me encanta que no cobren envío y la comida llega calientita. Los chilaquiles están buenísimos.",
    location: "Los Arcos"
  },
  {
    id: 2,
    name: "Carlos Rodríguez",
    rating: 5,
    comment: "Por WhatsApp es super fácil pedir. Sin apps complicadas y precios justos. Muy recomendado.",
    location: "Zona Centro"
  },
  {
    id: 3,
    name: "Ana Martínez",
    rating: 5,
    comment: "La comida sabe a casera de verdad. Me gusta que cocinen al momento, se nota la diferencia.",
    location: "Los Arcos"
  },
  {
    id: 4,
    name: "Luis Hernández",
    rating: 5,
    comment: "Excelente propuesta. Comida rica, precios accesibles y sin las comisiones de las apps tradicionales.",
    location: "Zona Norte"
  },
  {
    id: 5,
    name: "Patricia Jiménez",
    rating: 5,
    comment: "Pedí para la oficina y llegó exactamente a tiempo. La atención por WhatsApp es muy personalizada.",
    location: "Zona Centro"
  },
  {
    id: 6,
    name: "Roberto Silva",
    rating: 5,
    comment: "Los tacos al pastor son increíbles. Mejor que muchos restaurantes y a mitad de precio.",
    location: "Los Arcos"
  },
  {
    id: 7,
    name: "Laura Vega",
    rating: 5,
    comment: "Mi familia y yo pedimos cada semana. Siempre fresco, siempre rico, siempre puntuales.",
    location: "Zona Norte"
  },
  {
    id: 8,
    name: "Diego Morales",
    rating: 5,
    comment: "Trabajo desde casa y Salbox se volvió mi salvación. Comida rica sin salir de casa.",
    location: "Los Arcos"
  },
  {
    id: 9,
    name: "Carmen Ruiz",
    rating: 5,
    comment: "Las quesadillas son enormes y muy ricas. Excelente relación calidad-precio.",
    location: "Zona Centro"
  }
];

export const ReviewsCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const reviewsPerPage = 3;
  const totalPages = Math.ceil(reviews.length / reviewsPerPage);

  const nextReview = () => {
    setCurrentIndex((prev) => (prev + reviewsPerPage) % reviews.length);
  };

  const prevReview = () => {
    setCurrentIndex((prev) => {
      const newIndex = prev - reviewsPerPage;
      return newIndex < 0 ? Math.floor((reviews.length - 1) / reviewsPerPage) * reviewsPerPage : newIndex;
    });
  };

  const getCurrentReviews = () => {
    return reviews.slice(currentIndex, currentIndex + reviewsPerPage);
  };

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, i) => (
      <svg
        key={i}
        className={`w-5 h-5 ${i < rating ? 'text-orange-400' : 'text-salbox-neutral-300'}`}
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
    ));
  };

  return (
    <section id="resenas" className="py-16 bg-white scroll-mt-20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-lufga-semibold text-salbox-secondary mb-6 uppercase">
            Lo que dicen nuestros clientes
          </h2>
          <p className="text-lg font-lufga text-salbox-neutral-600 max-w-2xl mx-auto">
            Miles de clientes satisfechos respaldan la calidad de nuestro servicio.
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-6">
            {getCurrentReviews().map((review, index) => (
              <div key={review.id} className="bg-white rounded-xl p-6 shadow-xl border border-salbox-neutral-100 hover:shadow-2xl hover:-translate-y-2 hover:shadow-salbox-primary/20 transition-all duration-300 cursor-pointer">
                <div className="text-center">
                  <div className="w-12 h-12 bg-salbox-secondary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-lg font-lufga-semibold text-salbox-secondary">
                      {review.name.charAt(0)}
                    </span>
                  </div>

                  <div className="flex justify-center mb-4">
                    {renderStars(review.rating)}
                  </div>

                  <blockquote className="text-sm font-lufga text-salbox-neutral-700 mb-4">
                    "{review.comment}"
                  </blockquote>

                  <div>
                    <h4 className="font-lufga-semibold text-salbox-secondary text-sm">
                      {review.name}
                    </h4>
                    <p className="text-salbox-neutral-500 font-lufga text-xs">
                      {review.location}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 flex justify-center items-center space-x-6">
            <Button
              variant="outline"
              size="sm"
              onClick={prevReview}
              className="border-salbox-secondary text-salbox-secondary hover:bg-salbox-secondary hover:text-white"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </Button>

            <div className="flex space-x-2">
              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index * reviewsPerPage)}
                  className={`w-3 h-3 rounded-full transition-colors ${
                    Math.floor(currentIndex / reviewsPerPage) === index ? 'bg-salbox-secondary' : 'bg-salbox-neutral-300'
                  }`}
                />
              ))}
            </div>

            <Button
              variant="outline"
              size="sm"
              onClick={nextReview}
              className="border-salbox-secondary text-salbox-secondary hover:bg-salbox-secondary hover:text-white"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};